export default __webpack_public_path__ + "static/media/mgm-banner.0d7d2ea5.png";